/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Col, Row } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Avatar from "antd/es/avatar/avatar";
import useMedia from "use-media-antd-query";
import { loadTestimonialList } from "../../store/dashboard/actions";
import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router";
import moment from "moment";

const TravellerReview = () => {
  const media = useMedia();
  const dispatch = useDispatch();
  // const history = useHistory();

  //store integrations

  useEffect(() => {
    dispatch(loadTestimonialList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { testimonial_list = [] } = useSelector((state) => state.Dashboard);

  const testimonialData =
    testimonial_list !== undefined &&
    testimonial_list.length !== 0 &&
    testimonial_list.queryResult &&
    testimonial_list.queryResult.length > 0
      ? testimonial_list.queryResult.map((data) => {
          const testimonialDate = data.createdAt
            ? moment(data.createdAt).format("do MMM YYYY")
            : "";
          return {
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            createdByName: data.createdByName,
            status: data.status,
            date: testimonialDate,
            message: data.testimonialDescription
              ? data.testimonialDescription.replace(/<[^>]*>/g, "")
              : "",
            name: data.testimonialName,
            testimonialRole: data.testimonialRole,
            _id: data._id,
          };
        })
      : [];

  const [expandedItems, setExpandedItems] = useState({});

  const toggleText = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <React.Fragment>
      <Col
        md={24}
        lg={24}
        xl={24}
        xxl={24}
        className={
          media == "sm" || media == "xs"
            ? "mt-[50px] pl-[40px] pr-[40px]"
            : "mt-[70px] pl-[80px] pr-[80px]"
        }
      >
        <Row>
          <Col md={24} lg={24} xl={24} xxl={24} className="p-3 bg-[#f9f9f9]">
            <div
              style={{
                fontFamily: "Poppins",
                marginBottom: "1.5rem",
                //   boxShadow: "1px 1px 1px 2px lightgray",
              }}
            >
              <div className="flex text-[24px] font-extrabold text-start ">
                <h2 className="text-[#eb3a3e]">What</h2>
                <span className="ml-1">Travellers Say?</span>
              </div>
              <p className="text-[14px] mt-2 font-medium text-start">
                See real tourists and their real opinions, you create the best
                memories
              </p>
            </div>
            <Swiper
              modules={[Pagination]}
              spaceBetween={23}
              slidesPerView={2}
              pagination={{ clickable: true }}
              breakpoints={{
                350: { slidesPerView: 1 },
                1024: { slidesPerView: 2 },
              }}
              style={
                {
                  // marginBottom: "20px",
                }
              }
            >
              {testimonialData.length > 0 &&
                testimonialData.map((testimonial, index) => {
                  const maxLength = 140;
                  return (
                    <SwiperSlide color="#eb3a3e" key={index}>
                      <div
                        style={{
                          fontFamily: "Poppins",
                          //   boxShadow: "1px 1px 1px 2px lightgray",
                        }}
                        className="cursor-pointer p-5 mb-[70px] bg-white shadow-xl rounded-xl"
                      >
                        {expandedItems[index]
                          ? testimonial.message
                          : `${testimonial.message.slice(0, maxLength)}...`}
                        {testimonial.message.length > maxLength && (
                          <button
                            onClick={() => toggleText(index)}
                            style={{
                              marginLeft: "5px",
                              color: "#eb3a3e",
                              border: "none",
                              background: "none",
                              fontSize: "12px",
                              cursor: "pointer",
                              fontFamily: "Poppins",
                            }}
                          >
                            {expandedItems[index] ? "View less" : "View more"}
                          </button>
                        )}
                        <div className="mt-8 flex justify-between">
                          <div className="flex">
                            <Avatar
                              className="bg-[#c7c7c740]"
                              size={"default"}
                              shape="circle"
                            >
                              <UserOutlined className="text-lg text-[#eb3a3e]" />
                            </Avatar>
                            <div className="ml-1 mt-1 text-md font-bold text-gray-900">
                              {testimonial.name}
                            </div>
                          </div>
                          <div className="mt-1 text-xs text-gray-500">
                            {testimonial.date}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default TravellerReview;
